
import { Component, Vue } from "vue-property-decorator";
import PageFooter from "@/components/page-footer.vue";
import CollapseItem from "@/components/collapse.vue";
import shoplist from "@/components/shoplist.vue";
	import Switch from '@/components/switch.vue';
import {
  activitycouponactivityCouponInfo,
  activitycouponactivityCouponSave,
} from "@/api/finance"
import {
  nextDay
} from "@/utils"
@Component({
  name: "",
  components: {
    PageFooter,
    CollapseItem,
    shoplist,
		'slz-switch': Switch,
  },
})
export default class ProductList extends Vue {
  private loading = false;
  private form: any = {
    Id:0,
    ActivityCouponState:0,
    CouponName: "",
    ReceiveStartTime: "",
    ReceiveEndTime: "",
    ValidType: 0,
    StartTime: "",
    EndTime: "",
    ValidTime: "",
    ValidTime2: "",
    ActivityCouponType: 0,
    sill:0,
    FullMoney: 0,
    DerateMoney: "",
    miane: "",
    PerIdLimitReceiveCount: 1,
    AllCount: "",
    ReceiveCount: 0,
    UseInstruction: "",
    ActivityRangeType: 0,
    SpecifiedConditionType: null,
    SpecifiedConditionMoney: "",
    ActivityCouponProductList: [],
    CustomerRangeType:1,
    RegisterStartTime:'',
    RegisterEndTime:'',
    LastOrderTime:'',
    LastOrderTimeType:1,
    CustomerRangelist:[2],
    IsAllowTransfer:false,
    IsAllowReturn:false,
  };
  private comparelist = [
    { value: 1, label: "等于" },
    { value: 2, label: "大于" },
    { value: 3, label: "大于或等于" },
    { value: 4, label: "小于" },
    { value: 5, label: "小于或等于" },
  ];
  private Iscondition = 0
  private lastIscondition = 0
  private total = 0;
  private pageSize = 10;
  private pageNo = 1;
  private ActivityCouponProductList: any = [];
  private shopShow = false;
  private defaultThumb = "https://cdn2024.shiwuzone.com/routuanapp/default-thumb.png";
  private time1 = []


  private mounted () {
    if(Number(this.$route.query.Id)){
      this.getinfo()
    }
    
  }


  private falseCheck(e){
    if(e==0){
      this.Iscondition = this.lastIscondition
    }

    this.lastIscondition = e
  }
  private changeApplicablegoods(e){
    if(e==0){
      this.Iscondition = 0
      this.lastIscondition = 0
    }else{
      this.Iscondition = 1
      this.lastIscondition = 1
    }
  }
  private async getinfo(){
    try{
      this.loading = true
      let res = await activitycouponactivityCouponInfo({
        Id:this.$route.query.Id
      })
      if(res.IsSuccess){
        let form = res.Result
        form.ValidTime2 = ''
        if(form.ValidType==2){
          [form.ValidTime2,form.ValidTime] = [form.ValidTime,form.ValidTime2]
        }else if(form.ValidType==0){
          form.ValidTime = ''
        }
        if(form.ActivityCouponType==0){
          form.CustomerRangeType = 2
          form.CustomerRangelist = [1]
          form.RegisterStartTime = ''
          form.RegisterEndTime = ''
          this.time1 = []
          form.LastOrderTime = ''
          form.LastOrderTimeType = 1 
        }else{
          if(form.CustomerRangeType==3){
            form.RegisterStartTime = ''
            form.RegisterEndTime = ''
            this.time1 = []
            form.LastOrderTime = ''
            form.LastOrderTimeType = 1
          }else{
            if(form.RegisterStartTime&&form.RegisterEndTime){
              this.time1 = [form.RegisterStartTime,nextDay(form.RegisterEndTime,-1)]
            }else{
              form.RegisterStartTime = ''
              form.RegisterEndTime = ''
            }
            form.LastOrderTimeType = form.LastOrderTimeType?form.LastOrderTimeType:1
            if(form.LastOrderTimeType==1){
              form.LastOrderTime = nextDay(form.LastOrderTime,-1)
            }
          }
          if(form.CustomerRangeType==1){
            form.CustomerRangelist = [2,3]
          }else {
            form.CustomerRangelist = [form.CustomerRangeType]
          }
        }
        form.sill = form.FullMoney==0?0:1

        if(form.ActivityRangeType==2||form.ActivityRangeType==4){
          form.ActivityCouponProductList = form.ActivityCouponProductList.map(v=>{
            v.ImgUrlComplete = v.MainImgUrlComplete
            v. ImgUrl = v.MainImgUrl
            v.Id = v.ProductId
            return v
          })
        }

        
        if(form.ActivityRangeType==0){
          form.ActivityRangeType = 0
          this.Iscondition = 0
          this.lastIscondition = 0
          form.SpecifiedConditionType = null
          form.SpecifiedConditionMoney = ''
        }else if(form.ActivityRangeType==1){
          form.ActivityRangeType = 1
          this.Iscondition = 1
        }else if(form.ActivityRangeType==2){
          form.ActivityRangeType = 1
          this.Iscondition = 2
          this.lastIscondition = 2
          form.SpecifiedConditionType = null
          form.SpecifiedConditionMoney = ''
        }else if(form.ActivityRangeType==3){
          form.ActivityRangeType = 2
          this.Iscondition = 1
        }else if(form.ActivityRangeType==4){
          form.ActivityRangeType = 2
          this.Iscondition = 2
          this.lastIscondition = 2
          form.SpecifiedConditionType = null
          form.SpecifiedConditionMoney = ''
        }
          if(this.$route.query.IsCopy=='true'){
            form.Id = 0,
            form.ActivityCouponState = 0
            form.ReceiveCount = 0
          }

        this.form = JSON.parse(JSON.stringify(form))
        this.getActivityCouponProductList()
      }
    }finally{
      this.loading = false
    }
  }
  private changeType(e) {
    if (e == 0) {
      this.form.PerIdLimitReceiveCount = 1;
    } else {
      this.form.PerIdLimitReceiveCount = 0;
    }
  }
  private check() {
    let two = /^\d+(\.\d{1,2})?$/;
    if (!this.form.CouponName) {
      this.$message.error("请输入优惠券名称");
      return false;
    }
    if (!this.form.ReceiveStartTime || !this.form.ReceiveEndTime) {
      this.$message.error("请完善领取时间");
      return false;
    }
    if (new Date(this.form.ReceiveStartTime).getTime() > new Date(this.form.ReceiveEndTime).getTime()) {
      this.$message.error("开始时间不能晚于结束时间");
      return false;
    }
    if (this.form.ValidType == 0) {
      if (!this.form.StartTime || !this.form.EndTime) {
        this.$message.error("请设置优惠券使用期限");
        return false;
      }
      if (new Date(this.form.StartTime).getTime() > new Date(this.form.EndTime).getTime()) {
        this.$message.error("开始时间不能晚于结束时间");
        return false;
      }
    } else {
      let key = "ValidTime";
      if (this.form.ValidType == 1) {
        key = "ValidTime";
      } else if (this.form.ValidType == 2) {
        key = "ValidTime2";
      }
      if (this.form[key] < 1 || this.form[key] > 9999) {
        this.$message.error("使用期限允许1~9999天");
        return false;
      }
    }
        // console.log(this.form.CustomerRangelist)
    if(this.form.ActivityCouponType==1){
      if(!this.form.CustomerRangelist||!this.form.CustomerRangelist.length){
        this.$message.error("请选择领取人群");
        return false;
      }
    }
    if (this.form.sill == 1) {
      if (!this.form.FullMoney) {
        this.$message.error("请设置优惠券的使用门槛");
        return false;
      }
      if (this.form.FullMoney < 0.01 ||this.form.FullMoney > 999999.99 || !two.test(this.form.FullMoney)) {
        this.$message.error("使用门槛数值允许0.01~999999.99");
        return false;
      }
    }
    if (!this.form.DerateMoney) {
      this.$message.error("请设置优惠券面额");
      return false;
    }
    if (this.form.DerateMoney < 0.01 ||this.form.DerateMoney > 999999.99 || !two.test(this.form.DerateMoney)) {
      this.$message.error("优惠券面额数值允许0.01~999999.99");
      return false;
    }
    if (this.form.ActivityCouponType == 1) {
      if (this.form.PerIdLimitReceiveCount < 0 || this.form.PerIdLimitReceiveCount > 99999999 ||
       this.form.PerIdLimitReceiveCount != parseInt(this.form.PerIdLimitReceiveCount)) {
        this.$message.error("优惠券限领数量允许0~99999999");
        return false;
      }
    }
    if(!this.form.AllCount){
      this.$message.error("请设置优惠券总量");
      return false;
    }
    if (this.form.AllCount < 1 ||this.form.AllCount > 99999999 || this.form.AllCount != parseInt(this.form.AllCount)) {
      this.$message.error("优惠券总量允许1~99999999");
      return false;
    }
    if (this.form.AllCount < this.form.ReceiveCount) {
      this.$message.error("优惠券总量少于已发放数量，请重新设置");
      return false;
    }
    if (!this.form.UseInstruction) {
      this.$message.error("请设置使用说明");
      return false;
    }
    if(this.form.ActivityRangeType!=0){
      if(!this.Iscondition){
        this.$message.error("请设置参与条件或指定商品");
        return false;
      }
      if(this.Iscondition==1){
        if(!this.form.SpecifiedConditionType){
          this.$message.error("请选择条件类型");
          return false;
        }
        if(this.form.SpecifiedConditionMoney < 0.01 ||this.form.SpecifiedConditionMoney > 999999.99 || !two.test(this.form.SpecifiedConditionMoney)){
          this.$message.error("团购价金额异常，允许0.01~999999.99");
          return false;
        }
      }else{
        if(!this.form.ActivityCouponProductList||!this.form.ActivityCouponProductList.length){
          this.$message.error("请设置指定商品");
          return false;
        }
      }
    }
    return true;
  }
  private subForm(){
    let form = JSON.parse(JSON.stringify(this.form))
    if(form.ValidType==0){
      form.ValidTime = ''
      form.ValidTime2 = ''
    }else{
      let key = 'ValidTime'+(form.ValidType==1?'':2)
      form.ValidTime = form[key]
    }

    if(form.sill==0){
      form.FullMoney = 0
    }else{
      form.IsAllowReturn = false
    }

    if(form.ActivityCouponType==0){
      form.CustomerRangeType = 0
      form.RegisterStartTime = ''
      form.RegisterEndTime = ''
      form.LastOrderTime = ''
      form.LastOrderTimeType = 0
    }else{
      if(form.CustomerRangelist&&form.CustomerRangelist.length==1&&form.CustomerRangelist[0]==3){
        form.RegisterStartTime = ''
        form.RegisterEndTime = ''
        form.LastOrderTime = ''
        form.LastOrderTimeType = 0
        form.CustomerRangeType = 3
      }else{
        if(this.time1&&this.time1.length){
          form.RegisterStartTime = this.time1[0]
          form.RegisterEndTime = nextDay(this.time1[1],1)
        }else{
          form.RegisterStartTime = ''
          form.RegisterEndTime = ''
        }
        if(form.LastOrderTimeType==1){
          form.LastOrderTime = nextDay(form.LastOrderTime,1)
        }
        if(form.CustomerRangelist&&form.CustomerRangelist.length==2){
          form.CustomerRangeType = 1
        }else{
          form.CustomerRangeType = 2
        }
      }
    }


    if(form.ActivityRangeType==0){
      form.SpecifiedConditionType = null
      form.SpecifiedConditionMoney = ''
      form.ActivityCouponProductList = []
      form.ProductIdList = []
    }else{
      if(this.Iscondition==1){
        form.ActivityCouponProductList = []
        form.ProductIdList = []
        if(form.ActivityRangeType==1){
          form.ActivityRangeType=1
        }else if(form.ActivityRangeType==2){
          form.ActivityRangeType=3
        }
      }else{
        form.SpecifiedConditionType = null
        form.SpecifiedConditionMoney = ''
        form.ProductIdList = form.ActivityCouponProductList.map(v=>v.Id)
        form.ActivityCouponProductList = undefined
        if(form.ActivityRangeType==1){
          form.ActivityRangeType=2
        }else if(form.ActivityRangeType==2){
          form.ActivityRangeType=4
        }
      }
    }
    return form
  }
  private async save() {
    if (!this.check()) return;
    try {
      this.loading = true;
      let form = this.subForm()
      let res = await activitycouponactivityCouponSave(form);
      if (res.IsSuccess) {
        this.$message.success("保存成功");
        // this.$router.go(-1);
        this.$router.push({
          name:'coupon'
        })
      }
    } finally {
      this.loading = false;
    }
  }
  private delrow(row) {
    this.form.ActivityCouponProductList = this.form.ActivityCouponProductList.filter((v) => {
      return v.Id != row.Id;
    });
    this.getActivityCouponProductList();
  }
  private getshop(list) {
    if (!list || !list.length) {
      this.$message.error("请选择商品");
      return;
    }
    this.form.ActivityCouponProductList = list;
    this.shopShow = false;
    this.Iscondition = 2
    this.lastIscondition = 2
    this.getActivityCouponProductList();
  }
  private changePage(e) {
    this.pageNo = e;
    this.getActivityCouponProductList();
  }
  private getActivityCouponProductList() {
    this.total = this.form.ActivityCouponProductList.length;
    this.ActivityCouponProductList = this.form.ActivityCouponProductList.filter((v, i) => {
      return (i >= (this.pageNo - 1) * this.pageSize &&i < this.pageNo * this.pageSize);
    });
    // console.log(this.ActivityCouponProductList)
    if (this.pageNo > 1 && (!this.ActivityCouponProductList || !this.ActivityCouponProductList.length)) {
      this.pageNo--;
      this.getActivityCouponProductList();
    }
  }
}
